// extracted by mini-css-extract-plugin
export default {"FailedBookingsMessage__borderColor":"FailedBookingsMessage_FailedBookingsMessage__borderColor__+9t7g"};